import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SymptomsChecklist } from '../components/SymptomsChecklist';
import { EmotionalAnchor } from '../components/EmotionalAnchor';
import { WhyMedicineFails } from '../components/WhyMedicineFails';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { ProductIntroduction } from '../components/ProductIntroduction';
import { BonusStack } from '../components/BonusStack';
import { ValueStackTable } from '../components/ValueStackTable';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { UrgencyBlock } from '../components/UrgencyBlock';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export const LandingPage = () => {
  return <>
      <AnnouncementBar data-id="element-303" />
      <HeroSection data-id="element-304" />
      <StorySection data-id="element-305" />
      <SymptomsChecklist data-id="element-306" />
      <EmotionalAnchor data-id="element-307" />
      <WhyMedicineFails data-id="element-308" />
      <UniqueMechanism data-id="element-309" />
      <ProductIntroduction data-id="element-310" />
      <BonusStack data-id="element-311" />
      <ValueStackTable data-id="element-312" />
      <Testimonials data-id="element-313" />
      <Guarantee data-id="element-314" />
      <UrgencyBlock data-id="element-315" />
      <FinalCTA data-id="element-316" />
      <FAQ data-id="element-317" />
      <Footer data-id="element-318" />
    </>;
};